// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group-item[data-v-6a89948b] {\n  display: grid;\n  grid-template-columns: 25% 1fr;\n  grid-gap: 2rem;\n  line-height: 1.25;\n  padding-right: 1rem;\n}\n.group-item + .group-item[data-v-6a89948b] {\n  margin-top: 1rem;\n}\nspan[data-v-6a89948b] {\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
